module.exports = __webpack_public_path__ + "img/hk_room_floorplan_11_en.f1349934.png";